// extracted by mini-css-extract-plugin
export default {"sib-tooltip":"Ir4hCNTsMv430P63CA9w"};